export const notificationDefaultMessage = {
    SUCCESS: 'Successfully completed.',
    ERROR: 'Something went wrong.'
};

export const questionErrorMessage = {
    REQUIRED: 'This field is required.',
    INVALID_URL_FORMAT:
        'This is not a valid format. Please try starting with https:// or http://',
    MISSING: 'There are more than one missing fields',
    VALID_NUM: 'Must be a valid number',
    DUPLICATED_ERROR: 'Another option using same value',
    VALUE_MINIMUM: 'Value must be at least 1',
    VALUE_UNIQUE: 'Value must be unique',
    EXPRESSION_MINIMUM: 'Add at least one expression',
    RESEARCH_DOMAIN_LENGTH_LIMIT:
        'Research domain should be less than 20 characters',
    TOPIC_MINIMUM: 'Add at least one topics.',
    VALID_SELECTION:
        'The number of selection should be bigger than 0 and smaller than the number of seleceted questions',

    EMPTY_OPTIONS: 'Option card is required. Please add new option.',
    EMPTY_BUTTONS: 'Please add at least one button.',
    NUM_OPTIONS:
        'The min/max number must be smaller than the amount of options available.',
    LAYOUT_OPTION_INVALID:
        'Option displayed in a row should be smaller than or equal to total number of the option card added.',

    EMPTY_MIN_MAX: 'Please enter both Min and Max.',
    MIN_GREATER_THAN_MAX: 'Min value should not be greater than max value.',
    MIN_GREATER_THAN_ZERO: 'Min value should not be less than 1.',
    MAX_GREATER_THAN_ZERO: 'Max value should not be less than 1.',
    EMPTY_AREA_OPTIONS: 'You should define at least one area on the image',
    EMPTY_AREA_LABELS:
        "Please find 'Click here to add a label' message in the box area and add area label",
    UNIQUE_QUESTION_TITLE:
        'Please make sure the question title has a unique title within a project.',
    SPECIAL_CHARACTERS: 'Special characters are not allowed'
};
